module.exports = __webpack_public_path__ + "img/6d3e35d0-d688-11e8-828a-1334c9ae6ae8-image.7c27b21a.jpg";